import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import ReactSelect from "react-select";

const ReactSelectWrapper = props => {
	const {
		className,
		id,
		ariaLabel,
		ariaLabelledBy,
		menuPlacement,
		autoFocus,
		isDisabled,
		isMulti,
		isClearable,
		placeholder,
		isLoading,
		options,
		name,
		onChange,
		onKeyDown,
		onInputChange,
		onMenuClose,
		value,
		components,
		dataTestId,
	} = props;
	const [selectValue, setSelectValue] = useState(null);

	useEffect(() => {
		if (options.length > 0 && value !== null) {
			const initialValue = options.find(option => option.value === value) || null;
			setSelectValue(initialValue);
		}
	}, [options.length]);

	useEffect(() => {
		const compareValue = value instanceof Object ? value.value : value;
		const newValue = options.find(option => option.value === compareValue) || null;
		setSelectValue(newValue);
	}, [options, value]);

	return (
		<div data-test-id={dataTestId}>
			<ReactSelect
				className={classNames(className, "react-select")}
				classNamePrefix="react-select"
				isSearchable
				inputId={id}
				menuPlacement={menuPlacement}
				autoFocus={autoFocus}
				isDisabled={isDisabled}
				isMulti={isMulti}
				onKeyDown={onKeyDown}
				isClearable={isClearable}
				placeholder={placeholder}
				isLoading={isLoading}
				options={options}
				name={name}
				value={selectValue}
				onChange={onChange}
				onInputChange={onInputChange}
				onMenuClose={onMenuClose}
				aria-label={ariaLabel}
				aria-labelledby={ariaLabelledBy}
				components={components}
			/>
		</div>
	);
};

ReactSelectWrapper.propTypes = {
	name: PropTypes.string,
	className: PropTypes.string,
	id: PropTypes.string,
	ariaLabel: PropTypes.string,
	ariaLabelledBy: PropTypes.string,
	placeholder: PropTypes.string,
	menuPlacement: PropTypes.oneOf(["bottom", "top", "auto"]),
	options: PropTypes.array,
	value: PropTypes.any,
	autoFocus: PropTypes.bool,
	isDisabled: PropTypes.bool,
	isMulti: PropTypes.bool,
	isClearable: PropTypes.bool,
	isLoading: PropTypes.bool,
	components: PropTypes.object,
	onInputChange: PropTypes.func,
	onChange: PropTypes.func,
	onKeyDown: PropTypes.func,
	onMenuClose: PropTypes.func,
	dataTestId: PropTypes.string,
};

ReactSelectWrapper.defaultProps = {
	name: "",
	className: undefined,
	id: undefined,
	ariaLabel: undefined,
	ariaLabelledBy: undefined,
	placeholder: "Select...",
	menuPlacement: undefined,
	options: [],
	value: null,
	autoFocus: false,
	isDisabled: false,
	isMulti: false,
	isClearable: false,
	isLoading: false,
	components: {},
	onInputChange: () => {},
	onChange: () => {},
	onKeyDown: () => {},
	onMenuClose: () => {},
	dataTestId: undefined,
};

export default ReactSelectWrapper;
